<template>
    <div class="page">
        <img src="../assets/header.png" class="user-haead"/>
        <div class="ifo-item">
            <div class="info-title">姓名</div>
            <input class="info-value" type="text" placeholder="请输入姓名" v-model="name" />
        </div>
       
        <div class="ifo-item">
            <div class="info-title">手机号</div>
            <input class="info-value" type="number" placeholder="请输入手机号" v-model="phone" />
        </div>
         <div class="ifo-item">
            <div class="info-title">身份证号</div>
            <input class="info-value" type="number" placeholder="请输入身份证号" v-model="icCode" />
        </div>
        <div class="sure-action" @click="sureAction">确认</div>
    </div>
</template>

<script>
import { Toast } from "vant";
import { editUserInfo } from "@/api/api";
import { getUserInfo } from "@/api/api";
export default {
  name: "user-center",
  data() {
    return {
      headImg:
        "https://lstyg.oss-cn-shenzhen.aliyuncs.com/test/d4641cef-e1ab-453e-a71b-6860ae9c84c2.png",
      name: "",
      phone: "",
      icCode: "",
    };
  },
  methods: {
    getUserInfo() {
      getUserInfo().then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.headImg = res.data.headUrl;
          this.name = res.data.username;
          this.phone = res.data.telephone;
          this.icCode = res.data.userSfz;
        }
      });
    },
    sureAction() {
      if (this.name.length == 0) {
        Toast("用户昵称不能为空");
        return;
      }
      if (this.phone.length == 0) {
        Toast("用户手机号不能为空");
        return;
      }
      if (this.phone.length !== 11) {
        Toast("手机号应为11位");
        return;
      }
      if (this.icCode.length == 0) {
        Toast("身份证号不能为空");
        return;
      }
      if (this.icCode.length !== 18) {
        Toast("身份证号应为18位");
        return;
      }
      let params = {
        telephone: this.phone,
        userName: this.name,
        usersfz: this.icCode,
      };
      editUserInfo(params).then((res) => {
        if (res.code == 0) {
          Toast("保存用户信息成功");
          this.$router.replace({ path: "/" });
        }
      });
    },
  },
  mounted() {
    this.getUserInfo();
  },
};
</script>

<style scoped>
.page {
  margin-left: 16px;
  margin-right: 16px;
}
.user-haead {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: block;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 65px;
}
.ifo-item {
  margin-top: 15px;
}
.info-title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(40, 43, 49, 1);
  line-height: 28px;
}
.info-value {
  width: 100%;
  height: 49px;
  border-bottom: 1px solid #dfdfdf;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(103, 108, 117, 1);
  line-height: 49px;
}
.sure-action {
  width: 201px;
  height: 48px;
  background: rgba(255, 129, 80, 1);
  box-shadow: 0px 2px 8px 0px rgba(255, 129, 80, 0.2);
  border-radius: 25px;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 50px;
  font-size: 17px;
  font-family: PingFangTC-Semibold, PingFangTC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 48px;
  text-align: center;
}
</style>
